export default class User {
	constructor() {
		this.accountForm 	= document.querySelectorAll('#update-user .submit-button');
		this.accountLogOut 	= document.getElementById('button-logout');
		this.accountDelete 	= document.getElementById('delete-account');
		this.accountTabs 	= document.querySelectorAll('[data-tab]');

		// WORKING
		if(this.accountForm) {
			this.accountForm.forEach((button) => {
				button.addEventListener("click", (event) => {
					event.preventDefault();
					this.veritoneUpdateUser();
				});
			});
		}

		// WORKING
		if(this.accountLogOut) {
			this.accountLogOut &&
			this.accountLogOut.addEventListener("click", (event) => {
				event.preventDefault();
				this.veritoneLogOut();
			});
		}

		// Profile page navigation
		if(this.accountTabs) {
			let profileTabs = document.querySelectorAll('section[data-section]');
			this.accountTabs.forEach((tab) => {
				tab.addEventListener("click", () => {
					let tabToShow = document.querySelector('section[data-section="'+tab.dataset.tab+'"]');
					profileTabs.forEach(function (profileTab) {
						profileTab.classList.remove('visible');
					});
					tabToShow.classList.add('visible');
				});
			});
		}
	}

	// Veritone Update User
	veritoneUpdateUser() {
		document.body.classList.remove("loaded");
		let formData 	= new FormData(document.getElementById("update-user"));
		let onboardingErrors	= document.getElementById("update-user-errors");

		document.body.classList.remove("loaded");

		fetch('/wp/wp-admin/admin-ajax.php?action=veritoneUpdateUser', {
			method: 'POST',
			body: formData,
		})
		.then(response => response.json())
		.then(data => {
			document.body.classList.add("loaded");

			if(data['fieldErrors']) {
				data['fieldErrors'].forEach((error) => {
					onboardingErrors.innerHTML = error['message'];
				});
				onboardingErrors.classList.add('form-group__errors--open');
			} else {
				onboardingErrors.innerHTML = 'User account successfully updated.';
			}
			document.body.classList.add("loaded");
		})
	}

	// Veritone Log Out
	veritoneLogOut() {
		document.body.classList.remove("loaded");
		fetch('/wp/wp-admin/admin-ajax.php?action=veritoneLogOut', {
			method: 'POST',
		})
		.then(response => response.json())
		.then(data => {
			document.cookie = 'token' + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;'+"; path=/";
			document.location.href = "/";
			document.body.classList.add("loaded");
		})
	}
}